export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "mr", name: "Marathi", native: "मराठी" },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { code: "ta", name: "Tamil", native: "தமிழ்" },
  { code: "te", name: "Telugu", native: "తెలుగు" },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ" },
  { code: "ml", name: "Malayalam", native: "മലയാളം" },
  { code: "bn", name: "Bengali", native: "বাংলা" },
  { code: "ar", name: "Arabic", native: "العربية" },
  { code: "fr", name: "French", native: "Français" },
  { code: "es", name: "Spanish", native: "Español" },
  { code: "de", name: "German", native: "Deutsch" },
  { code: "zh", name: "Chinese", native: "中文" },
  { code: "ja", name: "Japanese", native: "日本語" },
];

export const TRANSLATIONS = {
  en: {
    home: "Home", products: "Products", dashboard: "Dashboard", cart: "Cart",
    login: "Login", register: "Sign Up", logout: "Logout",
    search_placeholder: "Search crops, farmers, regions...",
    hero_title: "Farm to World — Direct.",
    hero_subtitle: "Buy fresh produce from verified Indian farmers. Zero middlemen. Transparent prices. Global reach.",
    explore: "Explore Marketplace", become_farmer: "Sell on KisanBaazar",
    featured: "Featured Products", categories: "Shop by Category",
    organic: "Organic", export_ready: "Export Grade", auction: "Live Auction",
    add_to_cart: "Add to Cart", buy_now: "Buy Now", view_details: "View Details",
    moq: "MOQ", per: "per", farmer: "Farmer", location: "Location",
    schemes_title: "Government Schemes & Updates",
    stories_title: "Farmer Success Stories",
    testimonials_title: "What Buyers Say",
  },
  hi: {
    home: "होम", products: "उत्पाद", dashboard: "डैशबोर्ड", cart: "कार्ट",
    login: "लॉगिन", register: "साइन अप", logout: "लॉगआउट",
    search_placeholder: "फसल, किसान, क्षेत्र खोजें...",
    hero_title: "खेत से दुनिया तक — सीधा।",
    hero_subtitle: "सत्यापित भारतीय किसानों से ताज़ा उपज खरीदें। बिचौलिए नहीं। पारदर्शी कीमतें।",
    explore: "मार्केटप्लेस देखें", become_farmer: "KisanBaazar पर बेचें",
    featured: "विशेष उत्पाद", categories: "श्रेणी से खरीदें",
    organic: "जैविक", export_ready: "निर्यात ग्रेड", auction: "लाइव नीलामी",
    add_to_cart: "कार्ट में जोड़ें", buy_now: "अभी खरीदें", view_details: "विवरण देखें",
    moq: "न्यूनतम", per: "प्रति", farmer: "किसान", location: "स्थान",
    schemes_title: "सरकारी योजनाएँ और अपडेट",
    stories_title: "किसान सफलता की कहानियाँ",
    testimonials_title: "खरीदार क्या कहते हैं",
  },
  mr: {
    home: "मुख्यपृष्ठ", products: "उत्पादने", dashboard: "डॅशबोर्ड", cart: "कार्ट",
    login: "लॉगिन", register: "नोंदणी", logout: "लॉगआउट",
    search_placeholder: "पीक, शेतकरी, प्रदेश शोधा...",
    hero_title: "शेतापासून जगापर्यंत — थेट.",
    hero_subtitle: "प्रमाणित भारतीय शेतकऱ्यांकडून ताजी उत्पादने. मध्यस्थ नाही.",
    explore: "मार्केट पहा", become_farmer: "KisanBaazar वर विका",
    featured: "विशेष उत्पादने", categories: "श्रेणी प्रमाणे",
    organic: "सेंद्रिय", export_ready: "निर्यात दर्जा", auction: "लिलाव",
    add_to_cart: "कार्टमध्ये जोडा", buy_now: "आता खरेदी करा", view_details: "तपशील पहा",
    moq: "किमान ऑर्डर", per: "प्रति", farmer: "शेतकरी", location: "स्थान",
    schemes_title: "सरकारी योजना",
    stories_title: "शेतकरी यशकथा",
    testimonials_title: "ग्राहकांचे अभिप्राय",
  },
};

export const t = (lang, key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS.en[key] || key;
